
import Header from "../components/header";

export default function content(age) {
  return (
    <div className="flex flex-col px-8 py-8 text-2xl text-white leading-normal lg:leading-loose border bc-foreground w-full">
      <Header
        text={ "Welcome!" }>
      </Header>
      <p className='mt-6 mb-2'>
        Hi, welcome to my personal site.
      </p>
      <p className='my-2'>
        I'm Matt, a software developer from Huddersfield, West Yorkshire.
      </p>
      <p className='my-2'>
        I'm currently using <span>PHP</span>, <span>JavaScript</span>, <span>React</span>, <span>Gutenberg</span>, <span>WordPress</span> and <span>Next.js</span>.
      </p>
      <p className='my-2'>
        I have a <a className="underline font-bold cl-foreground" target="_blank" href="/degree">degree in Applied Software Engineering</a> from Cardiff University. 
      </p>
      <p className='mt-2'>
        I'm <span className='inline-block w-42'>{age}</span> years old and currently living in York, North Yorkshire.
      </p>
    </div>
  )
}